import BaseModel from './base';

export default class UserRating extends BaseModel {
  constructor(rating, url) {
    super(rating, url);

    this.id = rating.id;
    this.user_id = rating.user_id;
    this.month_rating = Number(rating.month_rating);
    this.rating = Number(rating.rating);
    this.year_rating = Number(rating.year_rating);
  }
}
